import React from 'react'

import qs from 'qs'
import { Link } from 'react-router-dom'
import { Tooltip as ReactTooltip } from 'react-tooltip'

import BottomButton from 'app/bond_cover/renters/sharedComponent/bottom_buttons_connection'
import * as Display from 'app/components/display/display'
import ProgressBarComponent from 'app/components/progress_bar/connection'
import BasicModal from 'app/modals/basic_modal'
import getParameter from 'app/shared_components/parameter_parser'
import Header from 'app/shared_components/rental_reputation_header_connection'
import { history } from 'app/shared_components/router'
import SnugTip from 'app/shared_components/snug_tips'
import EmergencyContactBox from 'app/sm/emergency_contact/components/emergency_contact_box'
import RequireDetailsModal from 'app/sm/emergency_contact/require_details_modal'
import { isFromApplication, urlTo, validateAddress } from 'app/sm/helpers'
import RentalReputationHeaderReminder from 'app/sm/rental_reputation_shared_component/header_reminder_connection'

class EmergencyContactAdd extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      SubmitBtnClicked: false,
      modalOpen: false,
      detailsModalOpen: false,
      detailsModalContent: 'Please check all emergency contact details.',
    }
  }

  componentDidMount() {
    const {
      getEmergencyContacts,
      addRentalReputationBackUrl,
      fetchCompleteness,
      fetchApplication,
      applicationDetails,
    } = this.props
    getEmergencyContacts()
    const propertyId = getParameter('propertyId')
    const applicationId = getParameter('applicationId')

    this.setState({
      applicationIdFromUrl: applicationId,
      propertyIdFromUrl: propertyId,
    })
    const curQueries = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })

    const { id: agencyID } = curQueries || {}

    if (agencyID) {
      this.setState({ agencyID, applicationId })
    }
    fetchCompleteness()
    applicationId && fetchApplication(applicationId)
  }

  btnTextChange = (isFromApplicationForm, applicant, SubmitBtnClicked) => {
    if (isFromApplicationForm) {
      if (!applicant.applied) {
        return (
          <div>
            Submit Application
            <i className={SubmitBtnClicked ? 'fa fa-spinner fa-pulse' : ''} />
          </div>
        )
      } else if (applicant.applied && applicant.isPrimary) {
        return (
          <div>
            Update
            <i className={SubmitBtnClicked ? 'fa fa-spinner fa-pulse' : ''} />
          </div>
        )
      }
    }
    return 'Complete'
  }

  checkForEmergencyContactLenth = (isFromApplicationForm = false) => {
    const {
      emergencyContacts = [],
      applicationDetails = {},
      addRentalReputationBackUrl,
    } = this.props
    const { config: applicationConfig = {}, offer = {} } =
      applicationDetails || {}
    const { applicationsSettingsConfig = {} } = applicationConfig || {}
    const {
      require_emergency_phone_and_email: requireEmergencyPhoneAndEmail = false,
      require_emergency_contact_address: requireEmergencyContactAddress = false,
    } = applicationsSettingsConfig || {}
    const { property: propertyOffer = {} } = offer || {}
    const { teamName = '' } = propertyOffer || {}
    const applicationId = getParameter('applicationId')
    // Validate applicationId before navigation
    if (
      isFromApplicationForm &&
      (!applicationId ||
        applicationId === 'undefined' ||
        applicationId === 'null')
    ) {
      this.setState({
        detailsModalOpen: true,
        detailsModalContent: (
          <>
            We've encountered an issue. Don't worry, your application has been
            saved.
            <br />
            <br />
            Please continue from My Applications.
            <br />
            <br />
            <small style={{ color: '#666' }}>Error code: 900488</small>
          </>
        ),
        detailsModalAction: () => {
          history.push(urlTo('MyApplications'))
        },
      })
      return
    }
    const nextUrl = isFromApplicationForm
      ? `${urlTo('applicationSummary', { applicationId })}${
          window.location.search
        }`
      : urlTo('RentalReputation')

    if (requireEmergencyPhoneAndEmail && emergencyContacts?.length > 0) {
      let hasValidContacts = true
      emergencyContacts.every((contact) => {
        const { phoneNumber, email } = contact || {}
        if (!phoneNumber || !email) {
          hasValidContacts = false
          return false
        }
        hasValidContacts = true
        return true
      })
      if (!hasValidContacts) {
        this.setState({
          detailsModalOpen: true,
          detailsModalContent: (
            <>
              {teamName} requires emergency contacts to have a valid phone
              number and email.
            </>
          ),
        })
        return
      }
    }
    if (requireEmergencyContactAddress && emergencyContacts?.length > 0) {
      let hasValidAddress = true
      emergencyContacts.every((contact) => {
        const { address } = contact || {}
        const { ok } = validateAddress(address)

        if (!ok || Object.keys(address).length === 0) {
          hasValidAddress = false
          return false
        }
        hasValidAddress = true
        return true
      })
      if (!hasValidAddress) {
        this.setState({
          detailsModalOpen: true,
          detailsModalContent: (
            <>
              {teamName} requires emergency contacts have a valid street
              address.
            </>
          ),
        })
        return
      }
    }
    if (emergencyContacts && emergencyContacts.length > 0) {
      addRentalReputationBackUrl(
        `${window.location.pathname}${window.location.search}`,
      )
      history.push(nextUrl)
    } else {
      this.toggleModal()
    }
  }

  confirmRemoveContact = (guidID) => {
    if (window.confirm('Are you sure?')) {
      this.props.removeEmergencyContact(guidID)
    }
  }

  isFromApplicationPortal = () => {
    const { backUrl } = this.props
    const { applicationIdFromUrl, propertyIdFromUrl } = this.state
    return (
      isFromApplication(backUrl) || applicationIdFromUrl || propertyIdFromUrl
    )
  }

  toggleModal = () => {
    const { modalOpen } = this.state
    this.setState({ modalOpen: !modalOpen })
  }

  toggleDetailsModal = () => {
    const { detailsModalOpen } = this.state
    this.setState({
      detailsModalOpen: !detailsModalOpen,
      detailsModalAction: null,
    })
  }

  render() {
    const { modalOpen, detailsModalOpen, detailsModalContent } = this.state
    const {
      emergencyContacts = [],
      backUrl,
      property,
      completeness,
      applicationDetails,
    } = this.props
    const { offer = {} } = applicationDetails || {}
    const { property: propertyOffer = {} } = offer || {}
    const { teamName = '' } = propertyOffer || {}

    const addNextOfKinModalBody =
      'Next of Kin and Emergency Contact required to complete a property rental application.'
    const isFromApplicationForm = this.isFromApplicationPortal()
    const { agencyID, applicationId } = this.state

    const isFromApplicationFormWithAgencyID = isFromApplicationForm && agencyID

    const urlToAdd = isFromApplicationFormWithAgencyID
      ? urlTo('emergencyContactAdd') +
        `?agencyID=${agencyID}&applicationId=${applicationId}`
      : urlTo('emergencyContactAdd')
    return (
      <Display.CenterContentContainer componentClass="width100">
        <ProgressBarComponent
          completeness={completeness}
          clickNextFunctionFromParentComponent={() =>
            this.checkForEmergencyContactLenth(isFromApplicationForm)
          }
        />
        <RentalReputationHeaderReminder
          property={property}
          backUrl={backUrl}
          remindText={'Current application'}
          isFromApplicationForm={isFromApplicationForm}
          title="Emergency Contact"
        />
        <Header
          title="Next of Kin and Emergency Contact"
          message="Add a Next of Kin (eg. parents, siblings) or Emergency Contact who does not reside with you, if required regarding your tenancy."
        />

        <div className="table mb20">
          <div className="cell-m-100">
            <h4>Add Next of Kin and Emergency Contact</h4>
          </div>
          <div className="cell-m">
            <Link className="btn btn-round" to={urlToAdd}>
              <i className="icon-add" />
            </Link>
          </div>
        </div>

        <div className="mb50">
          {(emergencyContacts || []).length > 0 &&
            emergencyContacts.map((contact) => (
              <EmergencyContactBox
                confirmRemoveContact={this.confirmRemoveContact}
                contact={contact}
                key={contact.guidID}
                agencyID={agencyID}
                applicationId={applicationId}
              />
            ))}
        </div>
        <ReactTooltip className="tooltip" />

        <SnugTip tipContent="Next of Kin and Emergency Contacts are required to apply for a property and only shared with property managers on the rental applications you submit." />
        <Display.BottomContentContainer>
          <Display.CenterContentContainer componentClass="width100">
            <div className="submit-button-container">
              <BottomButton
                btnText={isFromApplicationForm ? 'Save & Continue' : 'Complete'}
                clickNextFunction={() =>
                  this.checkForEmergencyContactLenth(isFromApplicationForm)
                }
                bottomButtonsClass="pt0 mt0 summary-bottom-button"
                nextBtnClass="summary-green-button-class"
                backButtonClass="summary-grey-button-class"
                nextButtonPositionClass="pr20 pl0"
                showArrow={false}
              />
            </div>
          </Display.CenterContentContainer>
        </Display.BottomContentContainer>
        {modalOpen && (
          <BasicModal
            toggleModal={this.toggleModal}
            title={'Add Next of Kin/ Emergency Contact'}
            body={addNextOfKinModalBody}
            primaryButtonLabel={'Add Contact'}
            primaryButtonAction={() => this.toggleModal()}
            showSecondaryButton={false}
          />
        )}
        {detailsModalOpen && (
          <RequireDetailsModal
            toggleModal={this.toggleDetailsModal}
            teamName={teamName}
            detailsModalContent={detailsModalContent}
            primaryAction={this.state.detailsModalAction}
            primaryLabel={
              this.state.detailsModalAction ? 'Go to My Applications' : null
            }
          />
        )}
      </Display.CenterContentContainer>
    )
  }
}

export default EmergencyContactAdd
